module.exports = __webpack_public_path__ + "img/Newbie_Dagger_01_Warrior.5bf9c50a.png";